/**
 * Whether this build talks to Novu. `NEXT_PUBLIC_*` is inlined at build time,
 * so a build without an app id (CI, a fork) has no `NovuProvider`, and every
 * consumer of the Novu hooks must stay unmounted — they throw outside it.
 */
export function isNovuEnabled(): boolean {
  return !!process.env.NEXT_PUBLIC_NOVU_APP_ID;
}
